import { Component, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { SharedModule } from '../../../../shared/shared.module';
import { HrmsService } from '../../../../services/hrms.service';
import { gridPageRequest } from '../../../../model/common/common.model';

@Component({
  selector: 'app-employee-component',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-employee-component.component.html',
  styleUrls: ['./list-employee-component.component.scss']

})
export class ListEmployeeComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  isEditMode: boolean = false;
  loader: boolean = false;
  employee: any[] = [];
  selectedEmployee: any[] = [];
  EmployeeList: any[] = [];
  searchKey: string = '';

  constructor(
    @Optional() public ref: DynamicDialogRef,
    @Optional() public config: DynamicDialogConfig,
    private messageService: MessageService,
    private router: Router, private routers: ActivatedRoute,
    private employeeService: HrmsService,
    private confirmationService: ConfirmationService

  ) { }

  submitted: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  selectedType: string | null = null;

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 200,
    id: 0
  }

  employeeForm = new FormGroup({
    // Basic Information
    employeeId: new FormControl('', Validators.required),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl(''),
    type: new FormControl('', Validators.required),
    contactName: new FormControl('', Validators.required),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', Validators.required),
      country: new FormControl('India', Validators.required),
    }),
    phone: new FormControl('', Validators.pattern(/^\d{10}$/)),
    mobile: new FormControl('', Validators.pattern(/^\d{10}$/)),
    prefix: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    // Work Information
    designation: new FormControl(''),
    job_Title: new FormControl(''),
    jobRole: new FormControl(''),
    work_Email: new FormControl('', Validators.email),
    employmentType: new FormControl(''),
    employeeStatus: new FormControl(''),
    location: new FormControl(''),
    dateOfJoining: new FormControl<Date | null>(null),
    reportingManager: new FormControl(''),
    gender: new FormControl(''),
    dob: new FormControl<Date | null>(null),
    website: new FormControl(''),
    facebook: new FormControl(''),
    twitter: new FormControl(''),
    // Education Details
    instituteName: new FormControl(''),
    degree: new FormControl(''),
    specialization: new FormControl(''),
    completionYear: new FormControl(''),
    internalNotes: new FormControl(''),
    IsActive: new FormControl(true),
  });

  ngOnInit(): void {
    document.title = 'Employee List';  
    this.searchEffect(); 
    this.getEmployees();

  }

  resetForm(form: FormGroup) {
    form.reset();
    _.forEach(form.controls, ctrl => ctrl.setErrors(null));
  }


  validateForm() {
    let isValid = true;
    if (this.employeeForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  cancel() {
    this.router.navigate(['/home/operations']);
  }

  getEmployees(): void {
    this.loader = true;

    this.employeeService.getEmployees(this.pageRequest).subscribe({
      next: async (data: any) => {
        if (data && data.employees) {
          this.EmployeeList = data.employees;
          await this.mapReportingManagers();

        } else {
          this.EmployeeList = [];
        }
        this.loader = false;
      },
      error: (error) => {
        console.error(error);
        this.loader = false;
      }
    });
  }

  async mapReportingManagers(): Promise<void> {
    const managerCache: Record<string, string> = {};

    for (const emp of this.EmployeeList) {
      if (emp.reportingManager) {
        const managerIds = emp.reportingManager.split(',').map((id: string) => id.trim());

        const managerNames: string[] = [];

        for (const id of managerIds) {
          if (!id) continue;

          if (managerCache[id]) {
            managerNames.push(managerCache[id]);
          } else {
            try {
              const managerData = await this.employeeService.getEmployeeByID(id).toPromise();
              const fullName = `${managerData.firstName || ''} ${managerData.lastName || ''}`.trim() || 'Unknown';
              managerCache[id] = fullName;
              managerNames.push(fullName);
            } catch (err) {
              console.error(`Failed to fetch manager ID ${id}:`, err);
              managerNames.push('Unknown');
            }
          }
        }

        emp.reportingManagerNames = managerNames.join(', ');
      } else {
        emp.reportingManagerNames = '—';
      }
    }
  }


  editEmployee(data?: any) {
    if (data) {
      const empData = data;
      this.router.navigate(['/home/createEmployees'], { queryParams: { 'empId': empData.empId }, skipLocationChange: false, });
    } else {
      const empData = this.selectedEmployee[0];
      this.router.navigate(['/home/createEmployees'], { queryParams: { 'empId': empData.empId }, skipLocationChange: false, });
    }

  }

  deleteEmployee() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        var empIds = _.map(this.selectedEmployee, 'empId');

        this.employeeService.deleteEmployee(empIds).subscribe({
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee deleted successfully.' });
            this.loader = false;
            this.selectedEmployee = [];
            this.getEmployees();
          },
          error: error => {
            this.loader = false;
            console.log(error);
          }
        })
      },
      reject: () => {
      }
    });

  }

  async searchEmployee() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter search keyword' });
      return;
    }

    this.loader = true;
    this.employeeService.autoSearchEmployee(this.searchKey).subscribe(
      async (data: any) => {
        if (data) {
          this.EmployeeList = data;
          await this.mapReportingManagers();

          if (this.dt1) {
            this.dt1.first = 0;
          }
        } else {
          this.EmployeeList = [];
        }
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  refreshData(): void {
    if (this.dt1) {
      this.dt1.reset();
    }
    this.searchKey = '';
    this.getEmployees();
  }

  loadEmployee(event: any) {
    if (this.searchKey)
      return;

    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + event.rows + 5;
    this.getEmployees();
  }


  placeholder: string = 'Search By ';
  private messages: string[] = ['Employee ID', 'Employee Name']; 
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }


}
